<template>
  <div class="roll">
    <div class="roll-warp">
      <div class="buy-btn-phone">
        <span @click="buyCarState=!buyCarState">我的购物车</span>
      </div>
      <div class="oran-sel">
        <div class="sel-top">
          <ul class="flex flex-w">
            <li v-for="(item,index) in selList" :key="item.id" @click="selOran(item)">
              <div class="seltop-warp" :class="{'seltop-warp1':searchForm.type_id==item.id}" @mouseenter="selMouseenter(item,'type_id')">
                <div class="img-box">
                  <img :src="item.img" />
                </div>
                <div class="p-1 name">{{ item.name }}</div>
              </div>
              <div v-if="item.subset.length>0" class="nav-justified-sort-detail" :class="{'nav-justified-sort-detail2':jisuan(index)}">
                <div class="nav-justified-sort-detail-left pull-right flex-0">
                  <img :src="subIMg" alt="" srcset="">
                </div>
                <div class="nav-justified-sort-detail-right pull-right">
                  <div class=" flex flex-w">
                    <div v-for="sub in item.subset" :key="sub.id" class="class-name p-1" @mouseenter="selMouseenter(sub,'subclass_id')" @click.stop="selSubclass(sub)">{{ sub.name }}</div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="class-box">
          <!-- <div class="class-list">
            <ul>
              <li :class="{'class-active':searchForm.subclass_id==''}" @click="selSubclass({id:''})">全部</li>
              <li v-for="item in classList" :key="item.id" :class="{'class-active':item.id==searchForm.subclass_id}" @click="selSubclass(item)">{{ item.name }}</li>
            </ul>
          </div> -->
          <div class="sel-bot">
            <div class="selbot-right">
              <div class="sort-block flex flex-0 flex-ac" :class="{'sort-top':searchForm.sort=='asc','sort-bottom':searchForm.sort=='desc'}" @click="selPrice">
                <span class="span1">价格</span>
                <div class="sort-icon flex">
                  <i class="el-icon-caret-top"></i>
                  <i class="el-icon-caret-bottom"></i>
                </div>
              </div>
              <el-input placeholder="按名称搜索" v-model="searchForm.searchKey" class="input1" @change="getList">
                <i slot="suffix" class="el-input__icon el-icon-search input1-i"></i>
              </el-input>
            </div>
          </div>
        </div>
      </div>
      <div class="roll-list">
        <ul>
          <li v-for="item in list" :key="item.id" @click="buyState(item)">
            <div class="list-warp">
              <div :class="item.state ? 'list-bor' : ''"></div>
              <span v-if="item.exteriorName" class="ico">{{ item.exteriorName }}</span>
              <span v-if="item.state" class="buy-state">
                <img src="@/assets/img/gou.png" />
              </span>
              <div class="list-img">
                <img :src="item.imageUrl" />
              </div>
              <div class="bot">
                <div class="list-name">{{ item.itemName }}</div>
                <div class="list-pirce">
                  <div class="pirce-left">
                    <img src="@/assets/images/masonry.png" class="money-img" />
                    <span>{{ item.price }}</span>
                  </div>
                  <div class="pirce-right">库存 {{ item.stock }}</div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="clear"></div>
      <empty v-if="list.length===0"></empty>
      <div class="csgo-page">
        <el-pagination background layout="prev, pager, next" :pager-count="5" :total="searchForm.totalSize" :page-size="searchForm.limit" @current-change="currentChange">
        </el-pagination>
      </div>
    </div>

    <div :class="buyCarState ? 'roll-right roll-right1' : 'roll-right'">
      <div class="off">
        <span @click="offAll">取消全部</span>
        <span class="buy-btn-phone1" @click="buyCarState=false">收起</span>
      </div>
      <div class="shopping-box">
        <div class="num-title">{{ total_num }} 饰品</div>
        <div class="shopping-cart">
          <ul>
            <li v-for="(item, index) in buyCart" :key="index">
              <div class="cart-warp">
                <div class="cart-top">
                  <div class="cart-img flex-0">
                    <img :src="item.imageUrl" />
                  </div>
                  <div class="cart-name">
                    <h5>{{ item.itemName }}</h5>
                    <h6>
                      <img src="@/assets/images/masonry.png" class="money-img" />
                      <span>{{item.price}}</span>
                    </h6>
                  </div>
                  <div></div>
                </div>
                <div class="cart-bot">
                  <span class="sub" @click="subBuy(item,index)">-</span>
                  <span class="num">{{ item.num }}</span>
                  <span class="add" @click="addBuy(item,index)">+</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="buy">
        支付
        <span>{{ total_price }}</span>
      </div>
      <div class="buy-btn">
        <!-- <span @click="goBuy">立即购买</span> -->
        <el-button class="el-btn" :disabled="loading" @click="goBuy" :style="{ 'background-color': loading ? '#e9b10e' : '#e9b10e' }">
          <i v-if="loading" class="el-icon-loading"></i>立即购买</el-button>
      </div>
    </div>
    <!-- <div class="clear"></div> -->
    <div class="myhomebot-mag"></div>
    <myhomebot></myhomebot>
    <div class="commonBg"></div>
  </div>
</template>

<script>
import myhomebot from "@/components/my_homebot.vue";
import { getToken } from '@/api/auth'
import empty from "@/g-components/empty.vue";

export default {
  components: { myhomebot, empty },
  data() {
    return {
      loading: false,
      buyCarState: false,
      searchForm: {
        recommend: '',
        new: '',
        type_id: '',
        subclass_id: '',
        sort: 'desc',
        searchKey: '',
        page: 1,
        totalSize: 0,
        limit: 20
      },
      subIMg: '',
      classList: [],
      selList: [],
      list: [],
      buyCart: [],
      total_num: 0,
      total_price: 0,
      priceSort: true,
      isMaxB: true
    };
  },
  mounted() {
    this.getListClass()
    this.getList()
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
    // this.getList(this.page);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      if (window.innerWidth > 767) {
        this.isMaxB = true
      } else {
        this.isMaxB = false
      }
    },
    jisuan(index) {
      if (this.isMaxB) {
        if (index % 9 > 5) {
          return true
        } else {
          return false
        }
      } else {
        if (index % 4 > 1) {
          return true
        } else {
          return false
        }
      }
      console.log(index)
    },
    //分类
    getListClass() {
      this.$doGet("/api/hall.LuckySkin/types").then((res) => {
        this.selList = res.data
        // if (res.data.length) {
        //   this.searchForm.type_id = this.selList[0].id
        // }
      }).catch(() => { })
    },

    //分页
    currentChange(val) {
      this.searchForm.page = val
      this.getList(val);
    },
    //点击分类获取列表
    selOran(item) {
      if (this.searchForm.type_id == item.id) {
        this.searchForm.type_id = ''
      } else {
        this.searchForm.type_id = item.id
      }
      this.searchForm.subclass_id = ''
      this.getList()
    },
    selMouseenter(item, type) {
      if (type == 'type_id') {
        if (item.subset.length == 0) {
          return false
        }
        this.subIMg = item.subset[0].img
      } else {
        this.subIMg = item.img
      }
    },
    selSubclass(item) {
      if (this.searchForm.subclass_id == item.id) {
        return
      }
      this.searchForm.subclass_id = item.id
      this.getList()
    },
    selPrice() {
      this.searchForm.sort = this.searchForm.sort ? this.searchForm.sort == 'asc' ? 'desc' : 'asc' : ''
      this.getList()
    },
    //商城列表
    getList() {
      this.$doGet("/api/hall.Store/skinList", this.searchForm).then((res) => {
        this.searchForm.totalSize = res.data.count
        this.list = res.data.list
        let ids = this.buyCart.map(v => v.id)
        for (let i = 0; i < this.list.length; i++) {
          let index = ids.indexOf(this.list[i].id)
          this.list[i].state = index != -1
          if (this.list[i].state) {
            this.list[i].num = this.buyCart[index].num
            this.buyCart[index] = this.list[i]
          }
        }
        this.$forceUpdate()
      }).catch(() => { })
    },
    //取消全部
    offAll() {
      this.buyCart = []
      for (let i = 0; i < this.list.length; i++) {
        this.list[i].state = false
      }
      this.buyNum()
    },
    //加一
    addBuy(item, index) {
      item.num = item.num + 1
      this.buyNum()
      this.$forceUpdate()
    },
    //减一
    subBuy(item, index) {
      if (item.num == 1) {
        item.state = false
        this.buyCart.splice(index, 1);
      } else {
        item.num = item.num - 1
      }
      this.buyNum();
      this.$forceUpdate();
    },
    buyState(item) {
      if (item.state) {
        this.buyCart = this.buyCart.filter(car => {
          return car.id != item.id
        })
        item.state = false
      } else {
        item.state = true
        item.num = 1
        this.buyCart.push(item)
      }
      this.buyNum();
      this.$forceUpdate();
    },
    //购物车数量和价格
    buyNum() {
      this.total_num = 0;
      this.total_price = 0;
      for (let i = 0; i < this.buyCart.length; i++) {
        this.total_num += this.buyCart[i].num;
        this.total_price += Number(this.buyCart[i].price) * this.buyCart[i].num;
      }
      this.total_price = this.total_price.toFixed(2);
    },
    //立即购买
    goBuy() {
      if (!this.$store.state.loginState) {
        this.$store.commit("getLogin", true);
        return;
      }
      this.loading = true;
      let skin_info = []
      this.buyCart.map(item => {
        skin_info.push({
          id: item.id,
          num: item.num,
          price: item.price
        })
      })
      this.$doPost("/api/hall.Store/buy", { skin_info, ApiToken: getToken() }).then((res) => {
        this.loading = false;
        this.buyCart = [];
        for (let i = 0; i < this.list.length; i++) {
          this.list[i].state = false;
        }
        this.total_num = 0;
        this.total_price = 0;
        this.$store.commit("getAboutMon", res.data)
        // this.$store.commit("getMoney", res.data.total_amount)
        this.$message({
          message: res.msg,
          type: "success",
        })
        this.getList()
      }).catch(() => {
        this.loading = false
      })
    }
  },
};
</script>

<style lang="less" scoped>
.roll {
  height: 100%;
  background: rgba(26, 28, 32, 0.9);
  .myhomebot-mag {
    margin-top: 120px;
  }

  .roll-warp {
    height: 100%;
    padding: 16px 266px 16px 16px;

    .roll-hint {
      font-size: 16px;
      color: #848493;

      span {
        color: #e9b10e;
      }
    }

    .roll-pirce {
      margin-top: 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .left {
        font-size: 14px;
        color: #e9b10e;
        font-weight: 600;
      }
      .left:hover {
        cursor: pointer;
        text-decoration: underline;
      }
      .right {
        display: flex;
        align-items: center;

        span {
          margin-left: 5px;
          margin-right: 5px;
          color: #e9b10e;
        }
        .screen {
          height: 40px;
          line-height: 40px;
          margin-left: 20px;
          background-color: #e9b10e;
          padding: 0 30px;
          font-weight: 600;
          color: #1a1c24;
          border-radius: 5px;
        }
        .screen:hover {
          cursor: pointer;
        }
        .input {
          width: 100px;
          img {
            width: auto;
            height: 15px;
          }
        }
        .input /deep/ .el-input__prefix,
        .el-input__suffix {
          top: 12.5px;
        }
        .input /deep/ .el-input__inner {
          background-color: #000;
          color: white;
          border: 1px solid #893e8a;
        }
      }
    }

    .roll-list {
      margin-top: 20px;
      ul {
        margin: 0 -4px;
        li {
          width: 25%;
          float: left;
          .list-warp {
            margin: 4px;
            border-radius: 5px;
            position: relative;
            overflow: hidden;
            background-color: #2b2c37;
            text-align: center;
            border-radius: 5px;
            // padding-top: 15px;
            .list-bor {
              position: absolute;
              top: 0;
              z-index: 2;
              width: 100%;
              height: 100%;
              background-color: rgba(233, 177, 14, 0.1);
            }
            .ico {
              position: absolute;
              top: 0;
              left: 0;
              font-size: 12px;
              color: #050505;
              background-color: #e6bd07;
              padding: 2px 4px;
            }
            .buy-state {
              position: absolute;
              top: 0;
              right: 0;
              img {
                width: 15px;
                height: 15px;
              }
            }
            .list-img {
              overflow: hidden;
              height: 130px;
              background: url('~@/assets/img/fight/item_bg.jpg') no-repeat;
              display: flex;
              align-items: center;
              justify-content: center;
              background-size: 100% 100%;
              img {
                width: auto;
                max-width: 100%;
                height: 100px;
              }
            }
            .bot {
              font-family: PingFangSC-Medium;
              padding: 0 20px;
              background-color: #2b2c37;
              .list-name {
                font-size: 16px;
                color: #c3c3e2;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .list-pirce {
                padding: 10px 0;
                display: flex;
                justify-content: space-between;
                .pirce-left {
                  display: flex;
                  align-items: center;

                  img {
                    width: auto;
                    height: 15px;
                    margin-right: 5px;
                  }
                  span {
                    color: #e9b10e;
                    font-size: 16px;
                  }
                }
                .pirce-right {
                  color: #848492;
                  font-size: 14px;
                }
              }
            }
          }
        }
        li:hover {
          cursor: pointer;
        }
        li:hover .bot {
          background-color: #484a5b;
          // box-shadow: 0 1px 5px 0 rgb(2 193 195 / 60%);
        }
      }
    }
  }

  .roll-right {
    position: fixed;
    width: 250px;
    height: 100%;
    top: 60px;
    right: 17px;
    z-index: 2;
    background-color: #30313f;
    .off {
      padding: 16px;
      background-color: #1a1c24;

      span {
        background-color: #30313f;
        border-radius: 5px;
        padding: 8px 16px;
        color: #848492;
        font-size: 14px;
        font-weight: 600;
      }
      span:hover {
        cursor: pointer;
      }

      .buy-btn-phone1 {
        display: none;
        margin-left: 10px;
        padding: 8px 16px;
        background-color: #e9b10e;
        border-radius: 5px;
        color: #1a1c24;
        font-size: 15px;
        font-weight: 600;
      }
    }
    .shopping-box {
      height: calc(~'100vh - 300px');
      .num-title {
        text-align: center;
        line-height: 40px;
        color: #e9b10e;
      }
      .shopping-cart {
        height: calc(100% - 40px);
        overflow: hidden;
        overflow-y: auto;
        ul li {
          margin: 0px 10px 10px;
          padding: 8px;
          background-color: #2b2c37;
          .cart-warp {
            .cart-top {
              display: flex;
              .cart-img {
                width: 70px;
                height: 55px;
                background-image: url('~@/assets/img/box-skins-blue.jpg');
                background-size: 100% 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                  width: auto;
                  max-width: 100%;
                  height: 45px;
                }
              }
              .cart-name {
                margin-left: 10px;
                h5 {
                  font-size: 14px;
                  color: #c3c3e2;
                }
                h6 {
                  display: flex;
                  align-items: center;
                  img {
                    width: auto;
                    height: 15px;
                  }
                  span {
                    margin-left: 5px;
                    color: #e9b10e;
                    font-size: 16px;
                  }
                }
              }
            }
            .cart-bot {
              display: flex;
              align-items: center;
              span {
                color: #c3c3e2;
              }
              .num {
                background-color: #444659;
                padding: 3px 12px;
                font-size: 15px;
              }
              .sub,
              .add {
                font-size: 24px;
                padding: 0 12px;
              }
              .sub:hover,
              .add:hover {
                cursor: pointer;
              }
            }
          }
        }

        img {
          width: 50px;
          height: 50px;
        }
      }
      /*滚动条样式*/
      .shopping-cart::-webkit-scrollbar {
        width: 4px;
        /*height: 4px;*/
      }
      .shopping-cart::-webkit-scrollbar-thumb {
        border-radius: 10px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(0, 0, 0, 0.2);
      }
      .shopping-cart::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 0;
        background: rgba(0, 0, 0, 0.1);
      }
    }
    .buy {
      background-color: #2b2c37;
      padding: 16px;
      text-align: center;
      font-size: 14px;
      color: #c3c3e2;
      span {
        margin-left: 10px;
        color: #e9b10e;
      }
    }
    .buy-btn {
      margin-top: 20px;
      text-align: center;
      .el-btn {
        color: #1a1c24;
        font-size: 15px;
        font-weight: 600;
      }
      span {
        color: #1a1c24;
        background-color: #e9b10e;
        padding: 8px 80px;
        border-radius: 5px;
        font-size: 15px;
        font-weight: 600;
      }
      span:hover {
        cursor: pointer;
        background-color: #f5c432;
      }
    }
  }
  .roll-right1 {
    display: block;
  }
  .buy-btn-phone {
    display: none;
    margin-top: 20px;
    span {
      padding: 8px 22px;
      background-color: #e9b10e;
      border-radius: 5px;
      color: #1a1c24;
      font-size: 15px;
      font-weight: 600;
    }
  }
}
</style>
